import ApiClient from "./../../api/src/ApiClient";

export const AUTHORIZED_USER = "auth_user";

export const UserStore = {
  namespaced: true,
  state: {
    authorizedUser: null,
    userPrices: {},
    userSettings: {
      B2B_CLIENT_PRICE_TYPE: "net",
      B2B_CLIENT_PRICE: "origin",
      B2B_CLIENT_MARGIN_TYPE: "percent",
      B2B_CLIENT_MARGIN: 0
    },
    addresses: [],
    accounts: [],
    keeper: {},
    salesrep: {}
  },

  mutations: {
    setAuthorizedUser(state, response) {
      state.authorizedUser = response;
    },

    prices(state, data) {
      if (data) {
        state.userPrices = data;
      } else {
        state.userPrices = {};
      }
    },

    userSettings(state, data) {
      if (data) {
        for (let settings of data) {
          state.userSettings[settings.name] = settings.value;
        }
      }
    },

    addresses(state, response) {
      state.addresses = response;
    },
    accounts(state, response) {
      state.accounts = response;
    },

    keeper(state, response) {
      state.keeper = response;
    },

    salesrep(state, response) {
      state.salesrep = response;
    }
  },

  actions: {
    isAuthorized({ commit, state }) {
      return state.authorizedUser != null;
    },

    async getKeeper({ commit, state }) {
      let result = await ApiClient.get("api/user/keeper");
      commit("keeper", result);
    },

    async getSalesRep({ commit, state }) {
      let result = await ApiClient.get("api/user/salerep");
      commit("salesrep", result);
    },

    async signin({ commit, state }, request) {
      let response = await ApiClient.signin(request);
      if (response != null) {
        this.dispatch("emit", {key: AUTHORIZED_USER, message: response.user});
        this.dispatch("categories/requestDataForce");
        this.dispatch("user/getPrices");
        this.dispatch("user/getUserSettings");
        this.dispatch("company/settings");
        commit("setAuthorizedUser", response.user);
      }
    },

    async restorePassword({ commit, state }, request) {
      await ApiClient.post("user/restorepassword", request);
      return true;
    },

    async changepassword({ commit, state }, request) {
      await ApiClient.post("user/changepassword", request);
    },

    async clearTicket({ commit, state }) {
      await ApiClient.signout();
    },

    async signout({ commit, state }) {
      await ApiClient.signout();
      commit("prices", null);
      commit("userSettings", [
        { name: "B2B_CLIENT_PRICE_TYPE", value: "net" },
        { name: "B2B_CLIENT_PRICE", value: "origin" },
        { name: "B2B_CLIENT_DISCOUNT", value: 0 },
        { name: "B2B_CLIENT_MARGIN", value: 0 }
      ]);
      commit("setAuthorizedUser", null);
      commit("addresses", null);
      commit("accounts", null);
      this.dispatch("emit", { key: AUTHORIZED_USER, message: null });
    },

    async getPrices({ commit, state }) {
      let result = await ApiClient.get("api/user/prices");
      let responseData = result.prices;
      let data = {}
      for(let pr of responseData) {
        data[pr.variant] = pr.price;
      }
      commit("prices", data);
    },

    async getUserSettings({ commit, state }) {
      let result = await ApiClient.get("api/user/settings");
      commit("userSettings", result);
    },

    async saveUserSetting({ commit, state }, setting) {
      let result = await ApiClient.post("api/user/settings", setting);
      commit("userSettings", result);
    },

    setUser({ commit }, user) {
      commit("setAuthorizedUser", user);
      this.dispatch("emit", { key: AUTHORIZED_USER, message: user });
    },

    async getAddresses({ commit, state }) {
      if (state.addresses.length == 0) {
        let result = await ApiClient.get("api/user/addresses");
        commit("addresses", result);
      }
    },

    async addAddress({ commit, state }, address) {
      let result = await ApiClient.post("api/user/address", address);
      let addresses = state.addresses;
      addresses.push(result);
      commit("addresses", addresses);
    },

    async getAccounts({ commit, state }) {
      if (state.accounts.length == 0) {
        let result = await ApiClient.get("api/user/accounts");
        commit("accounts", result);
      }
    },
    async editAccount({ commit }, data) {
      await ApiClient.post("api/user/account/edit", data);
      let result = await ApiClient.get("api/user/accounts");
      commit("accounts", result);
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/user/src/UserStore.js